export const FLIGHT_SEARCH_LIST = 'FLIGHT_SEARCH_LIST';
export const FLIGHT_MANIFEST_BOARDING = 'FLIGHT_MANIFEST_BOARDING';
export const FLIGHT_TRIP_BOARDING = 'FLIGHT_TRIP_BOARDING';
export const SET_SELECTED_FLIGHT_LEGKEY = 'SET_SELECTED_FLIGHT_LEGKEY';
export const ASSIST_QUEUE = 'ASSIST_QUEUE';
export const SEAT_MAP_TASK = 'SEAT_MAP_TASK';
export const AISLE = 'AISLE';
export const WINDOW = 'WINDOW';